import React, { useEffect } from 'react';

import { useQuery } from '@apollo/client';
import Loader from '../../../components/Loader/Loader';
import NotFound from '../../notFound/NotFound';

import ReportTypeForm from '../../../components/siteadmin/ReportTypeManagement/ReportTypeForm/ReportTypeForm';
import { getReportType } from '../../../lib/graphql';
import { useSelector } from 'react-redux';
import { formatLocaleData } from '../../../helpers/formatLocale';

const EditReportType = (props) => {
  const { id } = props;
  let dynamicReportTypeData, dynamicReportType = [], initialValues, activeLangugeCodes;
  const isActiveLanguages = useSelector(state => state?.runtime?.isActiveLanguages)

  activeLangugeCodes = isActiveLanguages.map((item) => { return formatLocaleData(item) })


  const { data, loading } = useQuery(getReportType, {
    variables: { id: Number(id) },
    fetchPolicy: 'network-only',
    ssr: false,
  });

  if (loading) {
    return <div><Loader type="text" /></div>;
  }
  if (!data?.getReportType?.result) {
    return <NotFound />
  }

  dynamicReportTypeData = data?.getReportType?.result && data?.getReportType?.result?.DynamicReportTypeData;

  if (dynamicReportTypeData && dynamicReportTypeData.length > 0) {
    dynamicReportType = dynamicReportTypeData.reduce((index, key) => {
      const { language, name, value } = key;
      const isActive = activeLangugeCodes?.includes(language);
      const activeLng = isActive ? language : '';
      let data = [];
      data = index.find(item => item.language === activeLng);

      if (data) {
        data[name] = value;
      } else {
        data = {
          language: activeLng,
          [name]: value
        };
        index.push(data);
      }
      return index;
    }, []);
  } else {
    dynamicReportType = [{
      reportContent: data?.getReportType?.result?.reportContent,
      reportType: data?.getReportType?.result?.reportType,
      language: 'en'
    }];
  }
  initialValues = {
    dynamicReportType: dynamicReportType,
    id: data?.getReportType?.result && data?.getReportType?.result?.id
  }


  return (
    <>
      <ReportTypeForm initialValues={initialValues} />
    </>
  );
};

export default EditReportType;
